import { render, staticRenderFns } from "./injurePhotos.vue?vue&type=template&id=00742916"
import script from "./injurePhotos.vue?vue&type=script&lang=js"
export * from "./injurePhotos.vue?vue&type=script&lang=js"
import style0 from "./injurePhotos.vue?vue&type=style&index=0&id=00742916&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports